import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardMedia,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { AppSingleton } from "../services/user_config";
import Matter from "matter-js";
import coke_icon from "../static/images/game_materials/coke.png";
import fish_bone_icon from "../static/images/game_materials/fish-bone.png";
import milk_icon from "../static/images/game_materials/milk.png";
import newspaper_icon from "../static/images/game_materials/newspaper.png";

// const buildBlock = ({ width, height, thickness, color, x, y }) => {
//   const ground = Matter.Bodies.rectangle(x + width / 2, y + height, width, thickness, {
//     isStatic: true,
//     render: { fillStyle: color },
//   });
//   const ceiling = Matter.Bodies.rectangle(
//     x + width / 2,
//     y,
//     width + thickness,
//     thickness,
//     { isStatic: true, render: { fillStyle: color } }
//   );
//   const leftWall = Matter.Bodies.rectangle(0, height / 2, thickness, height, {
//     isStatic: true,
//     render: { fillStyle: color },
//   });
//   const rightWall = Matter.Bodies.rectangle(
//     width,
//     height / 2,
//     thickness,
//     height,
//     {
//       isStatic: true,
//       render: { fillStyle: color },
//     }
//   );
//   return [ground, ceiling, leftWall, rightWall];
// };

const groundThickness = 24 / 2;
// const extraThickness = 12;

const getRecyclinBins = ({
  numberOfBins,
  recyclingBinWallThickness,
  spaceBetweenBin,
  bottomSpacer,
  colors,
}) => {
  const appSingleton = new AppSingleton();
  const startingPoint = appSingleton.windowSize.width / 3;
  // const numberOfBins = 4;
  // const recyclingBinWallThickness = 32;
  const recyclingBinHeight = 256;
  const recyclingBinWidth =
    (appSingleton.windowSize.width -
      startingPoint -
      (numberOfBins + 1) * spaceBetweenBin -
      recyclingBinWallThickness * numberOfBins * 2) /
    numberOfBins;
  const bins = Array(numberOfBins)
    .fill("")
    .map((_, _index) => {
      const index = _index + 1;
      const ground = Matter.Bodies.rectangle(
        startingPoint +
          spaceBetweenBin * index +
          recyclingBinWidth * _index +
          (recyclingBinWallThickness * 2 * _index + recyclingBinWallThickness) +
          recyclingBinWidth / 2, // X
        appSingleton.windowSize.height -
          recyclingBinWallThickness -
          groundThickness -
          appSingleton.topBarHeight -
          recyclingBinWallThickness / 2 -
          bottomSpacer, // Y
        recyclingBinWidth, // Width
        recyclingBinWallThickness, // Height
        {
          isStatic: true,
          render: { fillStyle: colors[_index] },
        }
      );
      const leftWall = Matter.Bodies.rectangle(
        startingPoint +
          spaceBetweenBin * index +
          recyclingBinWidth * _index +
          (recyclingBinWallThickness * 2 * _index + recyclingBinWallThickness), // X
        appSingleton.windowSize.height -
          groundThickness -
          recyclingBinWallThickness -
          appSingleton.topBarHeight -
          recyclingBinHeight / 2 -
          bottomSpacer, // Y
        recyclingBinWallThickness, // Width
        recyclingBinHeight, // Height
        {
          isStatic: true,
          render: { fillStyle: colors[_index] },
        }
      );
      const rightWall = Matter.Bodies.rectangle(
        startingPoint +
          spaceBetweenBin * index +
          (recyclingBinWallThickness * 2 * _index + recyclingBinWallThickness) +
          recyclingBinWidth * index, // X
        appSingleton.windowSize.height -
          groundThickness -
          recyclingBinWallThickness -
          appSingleton.topBarHeight -
          recyclingBinHeight / 2 -
          bottomSpacer, // Y
        recyclingBinWallThickness, // Width
        recyclingBinHeight, // Height
        {
          isStatic: true,
          render: { fillStyle: colors[_index] },
        }
      );
      return { ground, leftWall, rightWall };
    });
  return bins;
};

const getWorldBoundaries = () => {
  const appSingleton = new AppSingleton();
  // MARK: World (grounds) collision constraint
  const ground = Matter.Bodies.rectangle(
    appSingleton.windowSize.width / 2,
    appSingleton.windowSize.height -
      appSingleton.topBarHeight -
      groundThickness / 2,
    appSingleton.windowSize.width,
    groundThickness,
    {
      isStatic: true,
      render: { fillStyle: "red" },
    }
  );
  const ceiling = Matter.Bodies.rectangle(
    appSingleton.windowSize.width / 2,
    0,
    appSingleton.windowSize.width + groundThickness,
    // groundThickness + appSingleton.topBarHeight, // MARK: Top bar also the container area
    groundThickness, // MARK: Top bar also the container area
    {
      isStatic: true,
      render: { fillStyle: "red" },
    }
  );
  const leftWall = Matter.Bodies.rectangle(
    0,
    appSingleton.windowSize.height / 2,
    groundThickness,
    appSingleton.windowSize.height,
    {
      isStatic: true,
      render: { fillStyle: "red" },
    }
  );
  const rightWall = Matter.Bodies.rectangle(
    appSingleton.windowSize.width - groundThickness / 2,
    appSingleton.windowSize.height / 2,
    groundThickness,
    appSingleton.windowSize.height,
    {
      isStatic: true,
      render: { fillStyle: "red" },
    }
  );
  // [ground, ceiling, leftWall, rightWall].forEach((_rect) => {
  //   _rect.collisionFilter.category = 0x0001;
  // });
  return { ground, ceiling, leftWall, rightWall };
};

const RecyclingGame = () => {
  const appSingleton = new AppSingleton();
  const containerElementRef = useRef(null);

  var engine = Matter.Engine.create();
  var render = null;

  useEffect(() => {
    if (render === null) {
      render = Matter.Render.create({
        // element: document.body,
        element: containerElementRef.current,
        engine: engine,
        options: {
          width: appSingleton.windowSize.width - groundThickness / 2,
          height:
            appSingleton.windowSize.height -
            appSingleton.topBarHeight -
            groundThickness / 2,
          wireframes: false,
        },
      });

      const { ground, ceiling, leftWall, rightWall } = getWorldBoundaries();
      Matter.World.add(engine.world, [ground, ceiling, leftWall, rightWall]);

      // MARK: Recycling bin
      const categories = [
        { category: "paper", color: "blue" },
        { category: "aluminum", color: "yellow" },
        { category: "plastic", color: "brown" },
        { category: "food-waste", color: "grey" },
      ];
      const recyclingBins = getRecyclinBins({
        numberOfBins: 4,
        recyclingBinWallThickness: 16,
        bottomSpacer: 32,
        spaceBetweenBin: 8,
        colors: categories.map((el) => el.color),
      }).map((el, i) => {
        return {
          ...el,
          category: categories[i].category,
          color: categories[i].color,
        };
      });
      // console.log("recyclingBins");
      // console.log(recyclingBins);
      recyclingBins.forEach(({ ground, leftWall, rightWall }) => {
        Matter.World.add(engine.world, [ground]);
        Matter.World.add(engine.world, [leftWall]);
        Matter.World.add(engine.world, [rightWall]);
      });

      const getRandomBetween = (min, max) => {
        return Math.floor(Math.random() * (max - min) + min);
      };

      const itemStillCallback = ({ rect, item }) => {
        // console.log("rect");
        // console.log(rect);
        // console.log("item");
        // console.log(item);
        // TODO: Check recyling bins
        for (var i = 0; i < recyclingBins.length; i++) {
          const recyclingBin = recyclingBins[i];
          if (item.category === recyclingBin.category) {
            // TODO: check coordiante
            if (
              rect.bounds.min.x > recyclingBin.bounds.min.x &&
              rect.bounds.max.x < recyclingBin.bounds.max.x
            )
              console.log(`${item.name} hit bin: ${recyclingBin.color}`);
            Matter.World.remove(engine.world, rect);
            break;
          }
        }
      };
      const items = [
        {
          name: "coke",
          width: 75,
          height: 128,
          icon: coke_icon,
          category: "aluminum",
        },
        {
          name: "fish-honee",
          width: 128,
          height: 128,
          icon: fish_bone_icon,
          category: "food-waste",
        },
        {
          name: "milk",
          width: 96,
          height: 120,
          icon: milk_icon,
          category: "paper",
        },
        {
          name: "newspaper",
          width: 119,
          height: 128,
          icon: newspaper_icon,
          category: "paper",
        },
      ];

      const boxes = [...Array(20)].map(() => {
        const item = items[Math.floor(Math.random() * items.length)];
        const scale = 0.5;
        const boxWidth = item.width * scale;
        const boxHeight = item.height * scale;
        var itemRectangle = Matter.Bodies.rectangle(
          getRandomBetween(boxWidth, appSingleton.windowSize.width - boxWidth),
          getRandomBetween(
            boxHeight,
            appSingleton.windowSize.height - boxHeight
          ),
          boxWidth,
          boxHeight,
          {
            restitution: 0.5,
            friction: 0.2,
            render: {
              sprite: {
                texture: item.icon,
                xScale: scale, // MARK: image width 75
                yScale: scale, // MARK: image height 128
              },
            },
            // collisionFilter: {
            //   category: 0x0003,
            //   mask: 0x0001,
            // },
          }
        );
        // boxA.collisionFilter.mask = 0x0001; // allow big box to collide with small box

        Matter.Events.on(engine, "beforeUpdate", () => {
          setTimeout(() => {
            // Check if the object is still (velocity is close to zero)
            if (
              Math.abs(itemRectangle.velocity.x) < 0.01 &&
              Math.abs(itemRectangle.velocity.y) < 0.01
            ) {
              itemStillCallback({ rect: itemRectangle, item });
            }
          }, 1000);
        });
        return itemRectangle;
      });
      Matter.World.add(engine.world, boxes);
      // Create a mouse constraint
      const mouseConstraint = Matter.MouseConstraint.create(engine, {
        element: containerElementRef.current,
      });
      Matter.World.add(engine.world, [mouseConstraint]);
      Matter.Events.on(mouseConstraint, "enddrag", function (event) {
        var droppedBody = event.body;
        // TODO: after dropped get item x y, and recyclingBins .bounds .min / .max  .x  .y
        // droppedBody.collisionFilter.mask =
        //   droppedBody.collisionFilter.mask | 0x0002;
        console.log("Body dropped:", droppedBody);
      });

      // Run the engine
      Matter.Engine.run(engine);

      // Run the renderer
      Matter.Render.run(render);
    }
  }, []);

  return <Box ref={containerElementRef}></Box>;
};

export { RecyclingGame };
